/** Role checks. Backend source of truth: backoffice-service app/core/security.py ROLE_ALIASES and the role sets. */

export type RoleInput = string | string[] | null | undefined

/** Retired roles, read as their replacement. Mirrors backoffice-service ROLE_ALIASES. */
const LEGACY_ROLES: Record<string, string> = { wakil_pialang: 'dealing_settlement' }

export function normalizeRole(raw: string): string {
  const key = raw.trim().toLowerCase().replace(/\s+/g, '_')
  return LEGACY_ROLES[key] ?? key
}

function keys(role: RoleInput): string[] {
  const list = Array.isArray(role) ? role : [role || '']
  return list.map((item) => normalizeRole(item || '')).filter(Boolean)
}

function any(role: RoleInput, allowed: readonly string[]): boolean {
  const known = keys(role)
  return known.some((key) => allowed.includes(key))
}

/** Prefer every Cognito group; fall back to the single display role. */
export function accessOf(user?: { role?: string | null; groups?: string[] | null } | null): string[] {
  if (user?.groups?.length) return user.groups
  return user?.role ? [user.role] : []
}

export function canManageUsers(role: RoleInput): boolean {
  return any(role, ['admin', 'superadmin', 'super_admin'])
}

export function canOpening(role: RoleInput): boolean {
  return any(role, ['dealing_settlement', 'dealing', 'settlement']) || canManageUsers(role)
}

export function canSettlement(role: RoleInput): boolean {
  return any(role, ['dealing_settlement', 'dealing', 'settlement', 'director']) || canManageUsers(role)
}

export function canFinance(role: RoleInput): boolean {
  return any(role, ['finance']) || canSettlement(role)
}
